export const domain = window.location.protocol + '//' + window.location.host + "";

export const HOME = "/home";
export const FRIENDS = "/friends";
export const LEADER_BOARD = "/leader-board";
export const EARN = "/earn";
export const TASK = "/task";
export const DAILY_REWARD = "/daily-rewards";
export const SHOP_DOGS = "/shop-dogs";
export const BOOST = "/boost";
export const DEPOSIT = "/deposit";
export const WITHDRAW = "/withdraw";
export const TOP = "/top";
export const SPIN = "/spin";
export const HISTORY = "/history";